<template>
  <v-alert class="AppAlert pa-4"
           :class="{ 'AppAlert--bordered': hasLeftBorder }"
           :color="backgroundColor"
           :closable="dismissible"
           :rounded="rounded"
           :style="{ borderLeftColor: color }"
           close-icon="far fa-xmark"
           @update:model-value="$emit('input')"
  >
    <div class="d-flex align-center column-gap-4">
      <app-icon v-if="!noIcon" :icon-name="computedIcon"
                :style="{color: color}"
                icon-weight="fas"
      />
      <div class="d-flex align-center flex-grow-1">
        <div class="flex-grow-1">
          <p v-if="$slots['title']" class="text--small text--bold">
            <!-- @slot Use this slot for title -->
            <slot name="title"></slot>
          </p>
          <div>
            <!-- @slot Use this slot for alert text -->
            <slot></slot>
          </div>
        </div>
        <div v-if="$slots['button']" >
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { AppAlertBackgroundColor, AppAlertColor, AppAlertIcon } from '@/design-system/alert/enums'
import { AppAlertVariant } from '@/design-system/alert/types'

/**
 * Alert in app component.
 * @displayName In Page
 */
export default defineComponent({
  name: 'AppAlertInPage',
  props: {
    /**
     * Variant of the Alert.
     * @values info, success, error or warning
     */
    variant: {
      type: String as PropType<AppAlertVariant>,
      default: 'info',
    },
    /**
     * Adds a close icon that can hide the alert
     */
     dismissible: {
      type: Boolean,
      default: true,
    },
    /**
     * Remove icon before the alert text
     */
     noIcon: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    hasLeftBorder: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedIcon () {
      if (this.iconName) {
        return this.iconName
      }
      return AppAlertIcon[this.variant].valueOf()
    },
    backgroundColor () {
      return AppAlertBackgroundColor[this.variant].valueOf()
    },
    color () {
      return AppAlertColor[this.variant].valueOf()
    },
  },
})
</script>

<style scoped lang="scss">
.AppAlert {
  &--bordered {
    border-left-width: 8px;
    border-left-style: solid;
    border-collapse: collapse;
  }

  :deep(.v-alert__close i.v-icon) {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
</style>
